var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.scan}},[_vm._v("扫一扫")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }